import { BannerSectionTarget } from '@flipster/apis/v1/banner/types';
import { clearLocalStorageByPrefix, getLocalStorage, setLocalStorage } from '@flipster/utils/localStorage';

const inlineBannerDismissPrefix = 'flipster.configs.v1.bannerInline.';

const getDismissKey = (section: BannerSectionTarget, id: number) =>
  `${inlineBannerDismissPrefix}${section}.${id}` as `flipster.configs.v1.bannerInline.${string}.${number}`;

export const isInlineBannerDismissed = (section: BannerSectionTarget, id: number) =>
  getLocalStorage(getDismissKey(section, id)) === false;

export const dismissInlineBanner = (section: BannerSectionTarget, id: number) =>
  setLocalStorage(getDismissKey(section, id), false);

export const clearStaleInlineBannerDismiss = (section: BannerSectionTarget, activeIds: number[]) =>
  clearLocalStorageByPrefix(
    `${inlineBannerDismissPrefix}${section}.`,
    activeIds.map((id) => getDismissKey(section, id)),
  );
